export default __webpack_public_path__ + "static/media/icon-add.25bd8f56.svg";